import type { DiffItem } from "./types";

export const CHANGE_TYPE_LABELS: Record<DiffItem["changeType"], string> = {
  added: "Added",
  modified: "Modified",
  deleted: "Deleted",
  renamed: "Renamed",
  moved: "Moved",
};

export const CHANGE_TYPE_CLASSES: Record<DiffItem["changeType"], string> = {
  added: "bg-emerald-100 text-emerald-800",
  modified: "bg-amber-100 text-amber-800",
  deleted: "bg-rose-100 text-rose-800",
  renamed: "bg-sky-100 text-sky-800",
  moved: "bg-violet-100 text-violet-800",
};
